import React from "react";
import "./Building.css";
import { BoxProvider } from "../../Context/BoxContext"; // Import BoxProvider
import BoxWithContent from "../../Components/BoxWithContent"; // Import BoxWithContent component
import { useHrStyles } from "../../Context/HRContext";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Building() {
  const hrStyles = useHrStyles();

  // First Box Content
  const heading = "Interior";
  const description =
    "Transforming spaces into works of art that reflect your style and purpose. BEAMS delivers tailored interior designs that harmonize aesthetics with practicality, creating environments that inspire and comfort.";
  const image = "/assets/images/interior.jpg";
  const buttonVariant = "outline-danger";
  const gradientColor = "#DBFDDB"; // Customize gradient color for first box
  const link1 = "/Interior";

  // Second Box Content
  const heading2 = "Exterior";
  const description2 =
    "Crafting stunning exteriors that stand out while standing strong. From facades to outdoor spaces, BEAMS combines form and function to design exteriors that leave a lasting impression.";
  const image2 = "/assets/images/building1.jpg"; // Image for the second box
  const buttonVariant2 = "outline-danger";
  const gradientColor2 = "#DBFDDB"; // Customize gradient color for second box
  const link2 = "/Exterior";

  return (
    <>
      <BoxProvider
        heading={heading}
        description={description}
        image={image}
        gradientColor={gradientColor}
        buttonVariant={buttonVariant}
        link1={link1}
        heading2={heading2}
        description2={description2}
        image2={image2}
        gradientColor2={gradientColor2}
        buttonVariant2={buttonVariant2}
        link2={link2}
      >
        <hr style={hrStyles} />
        <p className="building-text">
          Architecture Tailored to <br />
          Inspire
        </p>
        <hr style={hrStyles} />
        <p className="building-description">
          At BEAMS, architecture is more than just design—it’s a blend of
          creativity, functionality, and innovation. We specialize in crafting
          interior, exterior, landscaping, and Vastu-inspired solutions that
          bring visions to life.
        </p>
        <BoxWithContent />
      </BoxProvider>

      <Container
        style={{
          marginTop: "2%",
          paddingRight: "10%",
          paddingLeft: "10%",
        }}
      >
        <div
          style={{
            width: "100%",
            margin: "0 auto",
            padding: "20px",
            borderRadius: "50px",
            background: `linear-gradient(to right, white, ${gradientColor})`, // First box gradient
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Row
              style={{
                paddingTop: "2%",
              }}
            >
              <Col md={6}>
                <img
                  src="/assets/images/l3.jpg"
                  alt="building3"
                  className="img-fluid"
                  style={{
                    maxWidth: "90%",
                    height: "auto",
                    minHeight: "16rem",
                    borderRadius: "25px",
                    float: "right",
                    marginRight: "15px",
                  }}
                />
              </Col>
              <Col md={6}>
                <h2
                  style={{
                    fontFamily: '"Inria Serif", serif',
                    fontWeight: "600",
                    fontSize: "2rem",
                    textAlign: "center",
                  }}
                >
                  Landscaping
                </h2>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "1rem",
                    marginTop: "7.5%",
                    marginBottom: "7.5%",
                  }}
                >
                  Designing outdoor spaces that merge beauty with functionality.
                  BEAMS creates breathtaking landscapes, integrating natural
                  elements and modern design to craft serene and sustainable
                  environments for relaxation and inspiration.
                </p>
                <Button
                  variant="outline-danger"
                  style={{
                    textAlign: "center",
                    padding: "10px 20px",
                    display: "block",
                    margin: "0 auto",
                    marginBottom: "10%",
                    borderRadius: "25px",
                  }}
                >
                  <Link
                    to="/Landscaping"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Find Out More
                  </Link>
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Container>

      <Container
        style={{
          marginTop: "2%",
          paddingRight: "10%",
          paddingLeft: "10%",
        }}
      >
        <div
          style={{
            width: "100%",
            margin: "0 auto",
            padding: "20px",
            borderRadius: "50px",
            background: `linear-gradient(to left, white, ${gradientColor})`,
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Row
              style={{
                paddingTop: "2%",
              }}
            >
              <Col md={6}>
                <h2
                  style={{
                    fontFamily: '"Inria Serif", serif',
                    fontWeight: "600",
                    fontSize: "2rem",
                    textAlign: "center",
                  }}
                >
                  Vastu Insights
                </h2>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "1rem",
                    marginTop: "7.5%",
                    marginBottom: "7.5%",
                  }}
                >
                  Bringing harmony and positivity to your spaces with expert
                  Vastu guidance. BEAMS blends traditional wisdom with
                  contemporary design to create environments that promote
                  well-being, balance, and prosperity.
                </p>
                <Button
                  variant="outline-danger"
                  style={{
                    textAlign: "center",
                    padding: "10px 20px",
                    display: "block",
                    margin: "0 auto",
                    marginBottom: "10%",
                    borderRadius: "25px",
                  }}
                >
                  <Link
                    to="/Vastu"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Find Out More
                  </Link>
                </Button>
              </Col>
              <Col md={6}>
                <img
                  src="/assets/images/vastu3.png"
                  alt="building3"
                  className="img-fluid"
                  style={{
                    maxWidth: "90%",
                    height: "auto",
                    minHeight: "16rem",
                    borderRadius: "25px",
                    float: "right",
                    marginRight: "15px",
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </>
  );
}
